<div class="header">
  <button
    pButton
    (click)="backButton()"
    class="back-button"
    severity="secondary"
    icon="ph ph-caret-left"
    aria-label="Back"></button>
  <dk-progress-bar [progressValues]="[100, 33.33, 0]"></dk-progress-bar>
  <span class="title-text">{{ 'doktar_app.auth.register.phone_number.title' | translate }}</span>
  <span class="subtitle-text">
    {{ 'doktar_app.auth.choose_password_description' | translate }}
  </span>
</div>

<span class="phone-input-label">
  {{ 'doktar_app.common.phone_number_label' | translate }}
</span>
<div class="phone-number-input-container">
  <p-select
    [options]="countries"
    [(ngModel)]="selectedCountry"
    optionLabel="name"
    [filter]="true"
    filterBy="name,phoneCode"
    [showClear]="false"
    appendTo="body"
    class="country-selector">
    <ng-template #selectedItem let-selectedOption>
      <div class="country-flag">
        <span class="flag-emoji view-only" [attr.title]="selectedOption.name">
          {{ selectedOption.flagEmoji | unicodeToEmoji }}
          {{ selectedOption.phoneCode }}
        </span>
      </div>
    </ng-template>
    <ng-template let-country #item>
      <div class="country-flag">
        <span class="flag-emoji" [attr.title]="country.name">{{ country.flagEmoji | unicodeToEmoji }}</span>
        <div>{{ country.phoneCode + ' ' + country.name }}</div>
      </div>
    </ng-template>
  </p-select>
  <p-inputNumber
    class="phone-number-input-mask"
    (ngModelChange)="onPhoneNumberChange($event)"
    [(ngModel)]="phoneNumber"
    [useGrouping]="false"
    [minlength]="6"
    [maxlength]="11"
    placeholder="000-00-00" />
</div>
<div class="continue-buttons">
  @if (somethingWentWrong) {
    <div class="error-container">
      <span class="error-text">
        {{ errorMessage | translate }}
      </span>
    </div>
  }
  <dk-button
    [size]="'xlarge'"
    class="continue-button"
    [label]="'doktar_app.common.continue' | translate"
    [disabled]="
      !phoneNumber || phoneNumber?.toString()?.length < 6 || !isValidPhoneNumber(phoneNumber.toString()) || !selectedCountry
    "
    [loading]="submitting"
    (onClick)="continuePhoneStep()"></dk-button>
  <dk-button class="skip-this-step-button" (onClick)="skipAndGoToNextStep()" [text]="true" severity="contrast">
    <span>
      <b>{{ 'doktar_app.common.skip_this_step' | translate }}</b>
    </span>
  </dk-button>
</div>
